exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".recording-tile .tile-body > i {\r\n    margin-top: 17px;\r\n    display: block;\r\n    font-size: initial;\r\n    line-height: initial;\r\n    text-align: center;\r\n    position: absolute;\r\n    bottom: 10px;\r\n    width: 100%;\r\n    text-align: center;\r\n    right: 0px;\r\n}\r\n\r\n.recording-tile i::before {\r\n    margin: 0px;\r\n    font-size: 30px;\r\n}\r\n\r\ndiv.tile-body div.number {\r\n    font-size: 15px;\r\n}\r\n\r\ndiv.tile-object p {\r\n    margin: 0px;\r\n    color: #FFFFFF;\r\n    line-height: 30px;\r\n}\r\n\r\n.tiles .tile {\r\n    max-width: 100px !important;\r\n    width: 100% !important;\r\n    min-width: 70px !important;\r\n    height: 110px;\r\n}\r\n\r\n.peak-flow-active {\r\n    position: relative;\r\n    top: 185px;\r\n}\r\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./src/app/case/details/trends/case-details-trends.component.css
// module id = 979
// module chunks = 1